import { ParameterSource } from '../../api/grpc/gen/family_service_pb';

// Plugin payloads may carry the enum either as a number (connect-es client)
// or as a proto-JSON name string (polled operations serialized by the plugin);
// both forms are accepted so mixed host versions degrade gracefully.
const PARAMETER_SOURCE_BY_NAME: Record<string, ParameterSource> = {
  UNSPECIFIED: ParameterSource.UNSPECIFIED,
  SHARED: ParameterSource.SHARED,
  PROJECT: ParameterSource.PROJECT,
  FAMILY: ParameterSource.FAMILY,
  BUILT_IN: ParameterSource.BUILT_IN,
};

export function normalizeParameterSource(value: unknown): ParameterSource | null {
  if (typeof value === 'string') {
    const shortName = value.trim().toUpperCase().replace(/^PARAMETER_SOURCE_/, '');
    const named = PARAMETER_SOURCE_BY_NAME[shortName];
    if (named !== undefined) {
      return named === ParameterSource.UNSPECIFIED ? null : named;
    }
  }

  const numeric = typeof value === 'number'
    ? value
    : typeof value === 'string' && /^\d+$/.test(value.trim())
      ? Number(value)
      : Number.NaN;
  if (Number.isInteger(numeric) && numeric >= ParameterSource.SHARED && numeric <= ParameterSource.BUILT_IN) {
    return numeric as ParameterSource;
  }

  return null;
}

const PARAMETER_SOURCE_LABELS: Readonly<Partial<Record<ParameterSource, string>>> = {
  [ParameterSource.SHARED]: 'Shared parameter',
  [ParameterSource.PROJECT]: 'Project parameter',
  [ParameterSource.FAMILY]: 'Family parameter',
  [ParameterSource.BUILT_IN]: 'Built-in parameter',
};

export function formatParameterSource(
  source: ParameterSource | undefined | null
): string | null {
  if (source === undefined || source === null) {
    return null;
  }

  return PARAMETER_SOURCE_LABELS[source] ?? null;
}
